import LandingLayout from './LandingLayout';
import { useLandingAnimations } from './useLandingAnimations';
import { useI18n } from '../../i18n/LanguageContext';
import { landingCopy } from './copy';
import { buildLandingPathForMarket, resolveLandingContext } from './regional';
import { useLocation } from 'react-router-dom';

export default function PatientAppPage() {
    useLandingAnimations();
    const location = useLocation();
    const { language } = useI18n();
    const { locale, market } = resolveLandingContext(location.pathname, language);
    const copy = landingCopy[locale].platform;
    const contactPath = `${buildLandingPathForMarket('/technology', market)}#contact`;

    return (
        <LandingLayout pageKey="patient-app">
            <section className="tech-header">
                <div className="container">
                    <h1 className="reveal-text">{copy.patientAppTitle}</h1>
                    <p className="tech-features-intro">{copy.patientAppSubtitle}</p>
                </div>
            </section>

            <section className="deep-dive tech-video-section">
                <div className="container patient-app-stack">
                    <p className="patient-app-badge">{copy.patientAppBadge}</p>
                    <p className="tech-features-intro">{copy.patientAppIntro}</p>
                    <div className="patient-app-launch-card">
                        <div className="patient-app-launch-copy">
                            <p className="patient-app-launch-eyebrow">{copy.patientAppLaunchEyebrow}</p>
                            <h2 className="patient-app-launch-title">{copy.patientAppLaunchTitle}</h2>
                            <p className="patient-app-launch-date">{copy.patientAppLaunchDate}</p>
                            <div className="patient-app-launch-cta">
                                <a href={contactPath} className="patient-app-btn-primary">{copy.patientAppLaunchPrimaryCta}</a>
                            </div>
                        </div>
                        <div className="patient-app-launch-visual">
                            <div className="patient-app-future-stage" aria-hidden="true">
                                <div className="patient-app-orbit patient-app-orbit-a"></div>
                                <div className="patient-app-orbit patient-app-orbit-b"></div>
                                <div className="patient-app-phone">
                                    <div className="patient-app-phone-notch"></div>
                                    <div className="patient-app-phone-screen">
                                        <div className="patient-app-scanline"></div>
                                        <div className="patient-app-grid"></div>
                                        <div className="patient-app-core-dot"></div>
                                        <p>{copy.patientAppLaunchTitle}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="features tech-features-overview">
                <div className="container">
                    <div className="features-grid">
                        {copy.patientAppFeatures.map((feature) => (
                            <div key={feature.title} className="feature-item">
                                <h3>{feature.title}</h3>
                                <p>{feature.body}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </LandingLayout>
    );
}
